export default {
  page_title: 'Réservations',
  page_description: 'Gérer les réservations de ressources',
  add_reservation: 'Ajouter une Réservation',
  edit_reservation: 'Modifier la Réservation',
  editTitle: 'Modifier la Réservation',
  resource: 'Ressource',
  user: 'Utilisateur',
  start_time: 'Heure de Début',
  end_time: 'Heure de Fin',
  from_date: 'Date de Début',
  until_date: 'Date de Fin',
  reserved_from: 'Réservé À Partir De',
  reserved_until: 'Réservé Jusqu\'À',
  status: 'Statut',
  notes: 'Notes',
  notes_placeholder: 'Entrez des notes sur cette réservation...',
  reserve: 'Réserver',
  from_date_past: 'La date de début de réservation ne peut pas être dans le passé',
  until_date_invalid: 'La date de fin de réservation doit être après la date de début',
  create: 'Créer',
  edit: 'Modifier',
  cancel: 'Annuler la Réservation',
  created_successfully: 'Réservation créée avec succès',
  updated_successfully: 'Réservation mise à jour avec succès',
  cancelled_successfully: 'Réservation annulée avec succès',
  invalid_time_range: 'L\'heure de fin doit être après l\'heure de début',
  pending: 'En Attente',
  active: 'En Cours',
  upcoming: 'À Venir',
  past: 'Passée',
  completed: 'Terminée',
  cancelled: 'Annulée',
  unknown_resource: 'Ressource Inconnue',
  unknown_user: 'Utilisateur Inconnu',
  overdue: 'En Retard',
  listView: 'Vue Liste',
  calendarView: 'Vue Calendrier'
};
